/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { CollectionsModule, MODULE_LAYOUTS } from '@coursera-web/cds-labs';

import { NUMBER_OF_RESULTS_PER_COLLECTION } from 'bundles/search-common/constants';

const styles = {
  container: css`
    margin: var(--cds-spacing-400) 0;
    border-radius: var(--cds-border-radius-200);
    overflow: hidden;
  `,
};
const BrowseInSearchCollectionsPlaceholder = () => {
  return (
    <div css={styles.container} data-testid="browse-in-search-collections-placeholder">
      <CollectionsModule
        numOfEntriesPerCollection={NUMBER_OF_RESULTS_PER_COLLECTION}
        isCollectionsLoading={true}
        layout={MODULE_LAYOUTS.text2image10}
        backgroundColor="grey"
        showRoundedCorners
      />
    </div>
  );
};
export default BrowseInSearchCollectionsPlaceholder;
